/**
 * PortalShell — shared chrome for membership / pending-user portals
 * (outside AdminLayout but same black-glass excellence craft).
 * Auth: Clerk (same app as admin).
 */

import type { ReactNode } from "react";
import { cn } from "@/lib/utils";

export function PortalShell({
  children,
  className,
  centered = true,
}: {
  children: ReactNode;
  className?: string;
  /** Center content vertically (pending access card). */
  centered?: boolean;
}) {
  return (
    <div
      className={cn(
        "portal-shell min-h-svh bg-neutral-950 text-white",
        "px-4 pt-[max(1.5rem,env(safe-area-inset-top))] pb-[max(1.5rem,env(safe-area-inset-bottom))]",
        centered && "flex items-center justify-center py-10",
        !centered && "py-10 md:py-14",
        className,
      )}
    >
      {children}
    </div>
  );
}

export function PortalCard({
  children,
  className,
  highlight = false,
}: {
  children: ReactNode;
  className?: string;
  highlight?: boolean;
}) {
  return (
    <div
      className={cn(
        "portal-card rounded-2xl border border-white/[0.08] bg-white/[0.03] shadow-xl shadow-black/40",
        "ring-1 ring-inset ring-white/[0.04]",
        highlight && "ring-1 ring-amber-500/30 shadow-lg shadow-amber-900/15",
        className,
      )}
    >
      {children}
    </div>
  );
}

export function PortalEyebrow({ children }: { children: ReactNode }) {
  return (
    <div className="text-[11px] font-semibold uppercase tracking-[0.14em] text-white/40">
      {children}
    </div>
  );
}
